import React from 'react';
import { HelpCircle } from 'lucide-react';
import LocationSearch from '../LocationSearch/LocationSearch';
import type { Location } from '@/types';

interface AppHeaderProps {
  onLocationSelect: (location: Location, displayName: string) => void;
  onUseCurrentLocation: () => void;
  isLoadingCurrentLocation: boolean;
  onReset: () => void;
  onAboutModalOpen: () => void;
}

const FlameIcon = () => (
  <svg width={16} height={16} viewBox="0 0 16 16" fill="none">
    <path d="M8 1.5c.8 1.6 2.4 2.6 2.4 4.6 0 1-.6 1.6-1.2 1.8.4-1.2-.2-2.2-1-2.8 0 1.4-.8 1.8-1.6 2.4-1 .8-1.6 2-1.6 3.4 0 2 1.4 3.6 3 3.6s3-1.6 3-3.6c0-2.7-1.5-4.4-3-9.4z" fill="#1a1d24"/>
  </svg>
);

export const AppHeader: React.FC<AppHeaderProps> = React.memo(({
  onLocationSelect,
  onUseCurrentLocation,
  isLoadingCurrentLocation,
  onReset,
  onAboutModalOpen,
}) => {
  return (
    <header style={{
      background: 'var(--paper-2)',
      borderBottom: '1px solid var(--paper-line)',
      position: 'sticky', top: 0, zIndex: 50,
    }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 16,
        padding: '0 28px', height: 60,
        maxWidth: 1800, margin: '0 auto',
      }}>
        {/* Brand */}
        <button
          onClick={onReset}
          style={{
            display: 'flex', alignItems: 'center', gap: 10,
            background: 'none', border: 'none', cursor: 'pointer',
            padding: 0, flexShrink: 0,
          }}
          title="Reset to initial state"
        >
          <div style={{
            width: 30, height: 30, background: 'var(--amber)', borderRadius: 8,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 1px 0 rgba(255,255,255,0.18) inset, 0 4px 12px rgba(245,165,36,0.30)',
          }}>
            <FlameIcon />
          </div>
          <span style={{
            fontWeight: 700, fontSize: 17, letterSpacing: '-0.02em',
            color: 'var(--paper-fg)',
          }}>
            FuelHunt
          </span>
        </button>

        {/* Search */}
        <div style={{ flex: 1, maxWidth: 560, marginLeft: 16 }}>
          <LocationSearch
            onLocationSelect={onLocationSelect}
            onUseCurrentLocation={onUseCurrentLocation}
            isLoadingCurrentLocation={isLoadingCurrentLocation}
            placeholder="Search UK postcode or city…"
          />
        </div>

        <div style={{ flex: 1 }} />

        {/* About */}
        <button
          onClick={onAboutModalOpen}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '6px 12px', borderRadius: 8, border: 'none',
            background: 'none', cursor: 'pointer',
            color: 'var(--paper-mute)', fontSize: 13.5,
          }}
          title="About FuelHunt"
        >
          <HelpCircle size={15} />
          <span>About</span>
        </button>
      </div>
    </header>
  );
});

AppHeader.displayName = 'AppHeader';

export default AppHeader;
